import { DocumentStatus } from '@cpce/ticketing-api';
import { hasJustificatifsAwaitingValidation } from './beneficiaries.utils.js';
import { sumDecimals } from './decimal.utils.js';
import { calculatePrestationDebt } from './prestations.utils.js';
export function computeEmployeeAlerts(employee) {
    const { employeeDocuments, employeeBeneficiaries, beneficiary } = employee;
    const awaitingValidation = employeeDocuments.filter((doc) => doc.status === DocumentStatus.awaitingValidation).length;
    const beneficiaryDocsAwaiting = employeeBeneficiaries.filter((eb) => eb.beneficiary.employeeBeneficiaryDocuments?.some((doc) => doc.status === DocumentStatus.awaitingValidation) || hasJustificatifsAwaitingValidation(eb.beneficiary.externalJustificatifs)).length;
    const allParticipationsRaw = [
        ...(beneficiary.prestationParticipations || []),
        ...employeeBeneficiaries.flatMap((eb) => eb.beneficiary.prestationParticipations || []),
    ];
    const allParticipations = [...new Map(allParticipationsRaw.map((p) => [p.id, p])).values()];
    const debtParticipations = allParticipations
        .map((participation) => {
        const remaining = calculatePrestationDebt(participation);
        if (!remaining.greaterThan(0))
            return null;
        return { id: participation.id, remaining };
    })
        .filter((p) => p !== null);
    const totalDebt = sumDecimals(debtParticipations.map((p) => p.remaining));
    return {
        documentValidationRequired: awaitingValidation,
        beneficiaryDocumentValidationRequired: beneficiaryDocsAwaiting,
        additionValidationRequired: false,
        debt: totalDebt.greaterThan(0)
            ? {
                total: totalDebt,
                prestationParticipationIds: debtParticipations.map((p) => p.id),
            }
            : undefined,
    };
}
export function toEmployeeListRow(employee) {
    return {
        id: employee.id,
        firstName: employee.beneficiary.firstName,
        lastName: employee.beneficiary.lastName,
        isActive: employee.beneficiary.isActive,
        status: employee.status,
        birthDate: employee.beneficiary.birthDate,
        alerts: computeEmployeeAlerts(employee),
    };
}
